/**
 * Subscription Module - Query Services
 */

import { useQuery } from '@tanstack/react-query';
import { useApi } from '../../../services/useApi';
import { GET_TRANSACTION_STATUS_URL } from '../constants';
import { IApiResponse, ITransactionStatusResponse } from '../types';

export const useGetTransactionStatus = (
  transactionGuid: string | undefined,
  options?: { enabled?: boolean; refetchInterval?: number | false }
) => {
  const { apiPublic } = useApi();

  return useQuery<ITransactionStatusResponse>({
    queryKey: ['transaction-status', transactionGuid],
    queryFn: async () => {
      const { data } = await apiPublic.get<IApiResponse<ITransactionStatusResponse>>(
        GET_TRANSACTION_STATUS_URL,
        { params: { transactionGuid } }
      );
      return data.result;
    },
    enabled: !!transactionGuid && (options?.enabled !== false),
    refetchInterval: options?.refetchInterval ?? false,
    refetchIntervalInBackground: false,
  });
};
